// extracted by mini-css-extract-plugin
export var arrow = "Paginator-module--arrow--aaeba";
export var arrowNo = "Paginator-module--arrow_no--87d63";
export var arrowYes = "Paginator-module--arrow_yes--19664";
export var centerControlsContainer = "Paginator-module--centerControlsContainer--d2aa9";
export var flex = "Paginator-module--flex--10af2";
export var flex1 = "Paginator-module--flex_1--c79f5";
export var flexCenter = "Paginator-module--flex_center--f31f5";
export var flexCenterCol = "Paginator-module--flex_center_col--6f882";
export var flexCol = "Paginator-module--flex_col--c356f";
export var flexFixCenterCol = "Paginator-module--flex_fix_center_col--1d117";
export var flexFixedCenterCol = "Paginator-module--flex_fixed_center_col--786f3";
export var jumpToPageContainer = "Paginator-module--jumpToPageContainer--93138";
export var jumpToPageInputField = "Paginator-module--jumpToPageInputField--55160";
export var jumpToPageLabel = "Paginator-module--jumpToPageLabel--b4d5a";
export var nextPageButtonContainer = "Paginator-module--nextPageButtonContainer--eafab";
export var pageButton = "Paginator-module--pageButton--7bb32";
export var pageButtonsContainer = "Paginator-module--pageButtonsContainer--86e1d";
export var pageIndicatorText = "Paginator-module--pageIndicatorText--bff8c";
export var pageIndicatorTextContainer = "Paginator-module--pageIndicatorTextContainer--74849";
export var paginationControlContainer = "Paginator-module--paginationControlContainer--cae2b";
export var paginationProgressbar = "Paginator-module--paginationProgressbar--e8d57";
export var previousPageButtonContainer = "Paginator-module--previousPageButtonContainer--43112";
export var progressbarWrapper = "Paginator-module--progressbarWrapper--fe49e";
export var rotating = "Paginator-module--rotating--5e691";
export var truncationButton = "Paginator-module--truncationButton--4c951";
export var truncationButtonLabel = "Paginator-module--truncationButtonLabel--fc024";